import React from 'react';
import { Row, Col } from 'reactstrap';
import { CURRENT_ENVIRONMENT, CLIENT_VERSION, BUILD_NUMBER, GIT_COMMIT } from '../config';

import { RootStateOrAny, useSelector } from 'react-redux';

const Footer = () => {

  const api_version = useSelector((state: RootStateOrAny) => state.apiVersion);
  return (
    <footer className="footer" role="contentinfo" aria-label="Footer">
      <Row className="footer-links" itemScope={true} itemType="https://schema.org/Organization">
        <Col className="text-center">
          <span className="value" itemProp="contactPoint" itemScope={true} itemType="https://schema.org/ContactPoint">
            <span itemProp="url"><a href="https://www.hhs.gov">U.S. Department of Health &amp; Human Services</a></span>
          </span>
        </Col>
        <Col className="text-center">
          <span className="value" itemProp="contactPoint" itemScope={true} itemType="https://schema.org/ContactPoint">
            <span itemType="url"><a href="https://www.cdc.gov/other/privacy.html">Privacy</a></span>
          </span>
        </Col>
        <Col className="text-center">
          <span className="value" itemProp="contactPoint" itemScope={true} itemType="https://schema.org/ContactPoint">
            <span itemType="url"><a href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html">Vulnerability Disclosure Policy</a></span>
          </span>
        </Col>
        <Col className="text-center">
          <span className="value" itemProp="contactPoint" itemScope={true} itemType="https://schema.org/ContactPoint">
            <span itemType="url"><a href="https://www.usa.gov/">USA.gov</a></span>
          </span>
        </Col>
        <Col className="text-center">
          <span className="value">
            <span>Source: CDC National Center for Health Statistics</span>
          </span>
        </Col>
      </Row>
      <Row>
        <Col className="text-right">
          <div className="build-info">
            <span>API Version: {api_version.version}</span>
            { CURRENT_ENVIRONMENT.showBuildInfo === true ?
              <span className="build-item">API Build: {api_version.build}</span>
            : ''}
            { CURRENT_ENVIRONMENT.showBuildInfo === true ?
              <span className="build-item">API Commit: {api_version.commit}</span>
            : ''}
            <br />
            <span>Client Version: {CLIENT_VERSION}</span>
            { CURRENT_ENVIRONMENT.showBuildInfo === true ?
              <span className="build-item">Client Build: {BUILD_NUMBER}</span>
            : ''}
            { CURRENT_ENVIRONMENT.showBuildInfo === true ?
              <span className="build-item">Client Commit: {GIT_COMMIT}</span>
            : ''}
          </div>
        </Col>
      </Row>
    </footer>
  );
}

export default Footer;